import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ContentSpacing, breakpoint } from '@estee/elc-base-theme';
import { translate, ITranslationsCollection } from '@estee/elc-service';
import { Heading5 } from '@estee/elc-typography';
import { IItemTypeahead } from '../../../internal/interfaces/ISearchInterfaces';
import SearchSuggestionsSkeleton from '../../../internal/views/skeletons/SearchSuggestionsSkeleton';
import { SearchSuggestionList } from './SearchSuggestionList';
import { SEARCH_PARAM, STATE_PARAM } from '../../constants/Search';
import { classes } from '../../utils/Classes';

const SearchSuggestionContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const SearchSuggestionsWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    height: 100%;
    list-style: none;
    padding: ${ContentSpacing.space10} 0;
    width: auto;
    ${breakpoint('desktop')`
        padding: ${ContentSpacing.space20} ${ContentSpacing.space24} 0;
    `};
`;

const SearchSuggestionHeading = styled(Heading5)`
    ${breakpoint('desktop')`
        padding-bottom: ${ContentSpacing.space20};
    `};
`;

export interface ISearchSuggestionProps {
    translations?: ITranslationsCollection;
    searchUrl?: string;
    limitedTypeaheadResults: IItemTypeahead[];
    searchTermSelected(searchTerm: string): () => void;
    isLoading: boolean;
}

@translate(['suggestedTopFilters'])
@observer
export class SearchSuggestion extends React.Component<ISearchSuggestionProps> {
    private searchSuggestionContainer: string = classes('search-suggestion-container');
    private searchSuggestionsWrapper: string = classes('search-suggestion-wrapper');
    private searchTypeaheadTitle: string = classes('search-typeahead-title');
    public render() {
        const { limitedTypeaheadResults, searchTermSelected, isLoading } = this.props;
        const { suggestedTopFilters } = this.props.translations as ITranslationsCollection;
        const searchUrl = `${this.props.searchUrl}`;

        return (
            (limitedTypeaheadResults.length > 0 || isLoading) && (
                <SearchSuggestionContainer className={this.searchSuggestionContainer}>
                    <SearchSuggestionsWrapper
                        className={this.searchSuggestionsWrapper}
                        data-test-id="SEA-Predective-Results-Section"
                    >
                        <SearchSuggestionHeading
                            className={this.searchTypeaheadTitle}
                            data-test-id="SEA-Suggested"
                            aria-label={suggestedTopFilters}
                            title={suggestedTopFilters}
                        >
                            {suggestedTopFilters}
                        </SearchSuggestionHeading>
                        {isLoading ? (
                            <SearchSuggestionsSkeleton />
                        ) : (
                            <SearchSuggestionList
                                searchUrl={searchUrl}
                                searchParam={SEARCH_PARAM}
                                filterParam={STATE_PARAM}
                                limitedTypeaheadResults={limitedTypeaheadResults}
                                searchTermSelected={searchTermSelected}
                            />
                        )}
                    </SearchSuggestionsWrapper>
                </SearchSuggestionContainer>
            )
        );
    }
}
